/**
 * EM 实体类弹出选择通用mixin
 *   提供EmModalEntitySelector组件的注册，及从不同组件中弹出该EmModalEntitySelector的方法
 *
 * 注意，必须设置EmModalEntitySelector组件的ref=emModalEntitySelector.才能正常使用本模块中的方法
 * Author YuJiaBei
 * Date 2020-07-12 08:14:36
 */
import EmModalEntitySelector from "@/components/em/EmModal/EntitySelector";

export default {
    components: {EmModalEntitySelector},
    methods: {
        /**
         * 从filter中弹出EmModalEntitySelector，选中值将写入vuex中的filter
         * @param popCol 弹出该组件的具体的col，内容是model.filterConfigs中某项元素
         * @param filterState
         * @param entity
         */
        $_emCommonModalMixin_showModalSelectorByFilter({popCol, filterState = 'filter', entity = this.entity} = {}) {
            this.$refs.emModalEntitySelector.showModal(entity, filterState, popCol, null)
        }, /**
         * 从entity中弹出EmModalEntitySelector，选中值将写入vuex中的entity
         * @param popCol 弹出该组件的具体的col，内容是model.filterConfigs中某项元素
         * @param entityState
         * @param entity
         */
        $_emCommonModalMixin_showModalSelectorByEntity({popCol, entityState = 'entity', entity = this.entity} = {}) {
            this.$refs.emModalEntitySelector.showModal(entity, entityState, popCol, null)
        },
        /**
         * 从行编辑的新增行弹出EmModalEntitySelector，选中值将写入vuex中的newRow
         * @param popCol 弹出该组件的具体的col，内容是model.filterConfigs中某项元素
         * @param popRow 弹出该组件的具体的row
         */
        $_emCommonModalMixin_showModalSelectorByNewRow(popCol, popRow) {
            this.$refs.emModalEntitySelector.showModal(this.modelName, 'newRow', popCol, popRow)
        },
        /**
         * 从行编辑的编辑行弹出EmModalEntitySelector，选中值将写入vuex中的editingRow
         * @param popCol 弹出该组件的具体的col，内容是model.filterConfigs中某项元素
         * @param popRow 弹出该组件的具体的row
         */
        $_emCommonModalMixin_showModalSelectorByEditRow(popCol, popRow) {
            this.$refs.emModalEntitySelector.showModal(this.modelName, 'editRow', popCol, popRow)
        },
        /**
         * 从谁也不关联的文本框弹出
         * @param popCol 弹出该组件的具体的col，内容是model.filterConfigs中某项元素
         * @param popRow 弹出该组件的具体的row
         */
        $_emCommonModalMixin_showModalSelectorByNormalInput(popCol, popRow) {
            this.$refs.emModalEntitySelector.showModal(this.modelName, 'editRow', popCol, popRow)
        },

        //----multiple----
        $_emCommonModalMixin_showMultipleSelectorByFilter({popCol, filterState = 'filter', entity = this.entity} = {}) {
            this.$refs.emModalEntitySelector.showMultipleModal(entity, filterState, popCol, null);
        },
        $_emCommonModalMixin_showMultipleSelectorByEntity({popCol, entityState = 'entity', entity = this.entity} = {}) {
            this.$refs.emModalEntitySelector.showMultipleModal(entity, entityState, popCol, null);
        },
        $_emCommonModalMixin_showMultipleSelectorByNewRow(popCol, popRow) {
            this.$refs.emModalEntitySelector.showMultipleModal(this.modelName, 'newRow', popCol, popRow)
        },
        $_emCommonModalMixin_showMultipleSelectorByEditRow(popCol, popRow) {
            this.$refs.emModalEntitySelector.showMultipleModal(this.modelName, 'editRow', popCol, popRow)
        },
        $_emCommonModalMixin_showMultipleSelectorByNormalInput(popCol, popRow) {
            this.$refs.emModalEntitySelector.showMultipleModal(this.modelName, 'editRow', popCol, popRow)
        },
    }
};